module.exports = __webpack_public_path__ + "static/media/SM-ST2-TRIAL.e8ac48bf.mp3";